export enum FilterTypes {
    common = "common",
    commonTrueOnly = "commonTrueOnly",
    size = "size",
    color = "color",
    price = "price",
}

/** Min options before the stores facet shows search + capped scroll height. */
export const FILTER_SEARCH_MIN_ITEMS = 7;

/** Algolia facet for horizontal PLP category navigation (Sneakers, Casual, etc.). */
export const TARGET_GROUP_FACET = "targetGroup";

/** Algolia facet for filtering products by store availability. */
export const STORES_FACET = "stores";

/** Algolia facet of `storeId|euSize` pairs for store/size cross-filtering on PLP. */
export const STORE_SIZES_AGG_FACET = "storeSizesAgg";
export const STORE_SIZES_AGG_SEPARATOR = "|";

export enum SizeLocales {
    EU = "EU",
    US = "US",
    UK = "UK",
    CA = "CA",
    KR = "KR",
    JP = "JP",
    AU = "AU/US",
    CN = "CN",
    CM = "CM",
}

export const getSizeFacetKey = (sizeLocale: SizeLocales | string): string => {
    if (sizeLocale === SizeLocales.AU) return "au";
    return sizeLocale.toLowerCase();
};

export const MAX_SHOE_SIZE = 50;
export const MIN_SHOE_SIZE = 19;
export const ONE_SIZE = "one";
export const INITIAL_RESULTS_NUMBER = 80;
export const HIERARCHICAL_CATEGORIES_SEPARATOR = ">";
export const AND_SYMBOL = "_AND_";

export enum ExtraPriceType {
    RRP = "RecommendedPrice",
    OMNIBUS = "OmnibusPrice",
    ADJUSTED = "AdjustedPrice",
}
